import {RefObject, useCallback, useEffect, useRef, useState} from 'react';

export const useIsElementVisible = <ContainerRef extends HTMLElement, ElementRef extends HTMLElement>(): {
  containerRef: RefObject<ContainerRef>;
  elementRef: RefObject<ElementRef>;
  isElementVisible: boolean;
} => {
  const containerRef = useRef<ContainerRef>(null);
  const elementRef = useRef<ElementRef>(null);
  const [isElementVisible, setIsElementVisible] = useState(false);
  const callbackFunction = useCallback(
    (entries: any) => {
      const [entry] = entries;
      setIsElementVisible(entry.isIntersecting);
    },
    [setIsElementVisible],
  );

  useEffect(() => {
    if (!elementRef.current || !containerRef.current) return;
    const currentRef = elementRef.current;
    const currentContainerRef = containerRef.current;

    const observer = new IntersectionObserver(callbackFunction, {
      root: currentContainerRef,
      rootMargin: '1px',
      threshold: 1,
    });

    observer.observe(currentRef);

    return () => {
      observer.unobserve(currentRef);
    };
  }, [elementRef, containerRef, callbackFunction]);

  return {containerRef, elementRef, isElementVisible};
};
